import { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { useLocation, useHistory } from "react-router-dom";

import  TicketListToolbar  from "../components/ticket/ticket-list-toolbar";
import AcademyService from "../services/AcademyService";

import { TabContent, TabPane } from "reactstrap";
import classnames from "classnames";

const Ticket = (props) => {

    const location = useLocation();
    const { student, period } = location.state;
    const academyService = new AcademyService();
    const [ activeTab, setActiveTab ] = useState(1);
    const [courses, setCourses] = useState([])
    let history = useHistory();
    

    const getCourses =  async () => {
      try{
        const response = await academyService.getScores(student.id, period);
        setCourses(response.data);

      } catch(error) {
        console.log(error);
      }
    }
   
    useEffect(() => {
      getCourses();
    }, []);

    return (
      <>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={1} className={classnames(["fade show"])}>
            <div className="row clearfix row-deck">
              <div className="col-xl-4 col-lg-4 col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Datos del Alumno</h3>
                  </div>
                  <div className="card-body">
                    <TicketListToolbar user={student} />
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-lg-8 col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title">Datos Academicos</h3>
                    <div className="card-options">
                      <div className="item-action dropdown ml-2">
                      {/* {this.props.status !== 2 &&  */}
                        <button onClick={() => history.goBack()} className="center btn btn-primary">
                          <i className="fe fe-file"></i> Volver
                        </button>
                      {/* } */}
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    {2 == 2 ? (
                      <table className="table table-striped mt-4">
                        <thead>
                          <tr>
                            <th rowSpan={2}>Asignatura</th>
                            <th className="w100 text-center" colSpan={2}>Practica 1</th>
                            <th className="w100 text-center" colSpan={2}>Practica 2</th>
                            <th className="w100 text-center" colSpan={2}>Examen Parcial</th>
                            <th className="w100 text-center" colSpan={2}>Responsabilidad</th>
                            {/* <th className="w100 text-center" colSpan={2} style={{backgroundColor: '#5d2837', color:'white'}}>Promedio Final</th> */}
                          </tr>
                          <tr>
                            
                          </tr>
                        </thead>
                        <tbody>
                          {courses?.map((course) => (
                            <tr key={course.id} style={String(course.id).includes("a") ? {background: '#5d2837', color: 'white'} : {}} >
                              <td>{course.name}</td>
                              <td>{course.scores.p1.score}</td>
                              <td>{course.scores.p1.letterScore}</td>
                              <td>{course.scores.p2.score}</td>
                              <td>{course.scores.p2.letterScore}</td>
                              <td>{course.scores.eXP.score}</td>
                              <td>{course.scores.eXP.letterScore}</td>
                              <td>{course.scores.rES.score}</td>
                              <td>{course.scores.rES.letterScore}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      // <Stack spacing={2}>
                      //   <Alert
                      //     variant="soft"
                      //     color="danger"
                      //     invertedColors
                      //     startDecorator={
                      //       <CircularProgress size="lg" color="danger">
                      //         <Warning />
                      //       </CircularProgress>
                      //     }
                      //     sx={{ alignItems: 'flex-start', gap: '1rem' }}
                      //   >
                      //     <Box sx={{ flex: 1 }}>
                      //       <Typography level="title-md">Se perdió la conección</Typography>
                      //       <Typography level="body-md">
                      //         Tenemos un problema con el servidor. Si el problema persiste comunícate con la institución.
                      //       </Typography>
                      //       <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                      //         {/* <Button variant="outlined" size="sm">
                      //           Open network settings
                      //         </Button>
                      //         <Button variant="solid" size="sm">
                      //           Try again
                      //         </Button> */}
                      //       </Box>
                      //     </Box>
                      //   </Alert>
                      // </Stack>
                      <></>
                    )}
                  </div>
                  <div className="card-footer">
                    <small>
                      {/* Colegios Monserrat */}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </TabPane>
        </TabContent>
      </>
    );
  
};


const mapStateToProps = (state) => {
  return {
    user: state.user,
    campus: state.campus,
    filters: state.filters,
  };
};

export default connect(mapStateToProps)(Ticket);